import { RES_TYPES, useFetch } from "@chainless/chainless-react";
import { useEffect } from "react";
import { FaTrash } from "react-icons/fa";

export const DeleteVGMItem = ({ url, refresh }) => {
  const {
    data,
    error,
    fetchData: deleteItem,
  } = useFetch(url, {
    method: "DELETE",
    resType: RES_TYPES.text,
    lateFetch: true,
  });

  const handleDelete = () => {
    if (window.confirm("Weet u het zeker?")) {
      deleteItem();
    }
  };

  useEffect(() => {
    if (data) {
      refresh();
    }
  }, [data, refresh]);

  useEffect(() => {
    if (error) {
      alert("Fout bij het verwijderen van een item");
    }
  }, [error]);

  if (url) {
    return (
      <>
        <FaTrash onClick={handleDelete} className="update-icon" />
      </>
    );
  }
};
